import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import AlertItem from 'modules/emergencies/components/log/LogItem';
import AlertHeader from 'modules/emergencies/components/log/logComponents/Header';
import LogsItemContainer from 'modules/emergencies/components/ui/containers/logsItemContainer';
import ALERTS_VERBS from 'modules/emergencies/components/alerts/alertsConstants';
import BasicLoader from 'modules/emergencies/components/ui/loaders/basicLoader';
import ErrorText from 'modules/emergencies/components/ui/texts/RedBackgroundText';
import Mask from 'modules/emergencies/components/ui/layout/Mask';
import LoaderButtonContainer from 'modules/emergencies/components/ui/containers/loaderButtonContainer';
import useAlertsList from './useAlertsList';
import { LoadMoreButton } from 'modules/emergencies/components/ui/buttons/LoadMoreButton';

const StyledLoader = styled(BasicLoader)`
  padding: 16px;
`;

const AlertsList = ({ className, cancel }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [currentLoadedPage, setCurrentLoadedPage] = useState(1);
  const { alertsData, alertsError, isLoadingAlerts } = useAlertsList({ currentPage });
  const [totalAlerts, setTotalAlerts] = useState(undefined);

  const canShowAlerts = typeof totalAlerts !== 'undefined' && !alertsError;

  useEffect(() => {
    if (totalAlerts === undefined) {
      if (!alertsError && typeof alertsData !== 'undefined') {
        setTotalAlerts(alertsData);
      }
    } else {
      if (currentPage > currentLoadedPage && !alertsError && typeof alertsData !== 'undefined') {
        const newTotalAlertsResults = [...totalAlerts.results, ...alertsData.results];
        const uniqueAlertsResults = newTotalAlertsResults.filter(
          (v, i, a) => a.findIndex((v2) => v2.id === v.id) === i
        );
        const orderedAlertsResults = uniqueAlertsResults.sort(
          (a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
        );
        const newTotalAlerts = {
          ...totalAlerts,
          results: orderedAlertsResults,
        };
        setTotalAlerts(newTotalAlerts);
        setCurrentLoadedPage(currentPage);
      }
    }
  }, [alertsData, alertsError, currentLoadedPage, currentPage, totalAlerts]);

  const filterUnreadAlerts = () => {
    return totalAlerts.results.filter((alert) => alert.unread);
  };

  const hasMoreAlerts = !!totalAlerts && totalAlerts.count > totalAlerts.results.length;

  const markAsRead = () => {
    const alertsToMarkAsRead = filterUnreadAlerts();
    cancel({ alertsToMarkAsRead });
  };
  const goToTicket = (id) => {
    const alertsToMarkAsRead = filterUnreadAlerts();
    cancel({
      alertsToMarkAsRead,
      url: `/emergencies/${id}`,
    });
  };
  const IDProps = { hasID: true, onIDClick: goToTicket };
  return (
    <div className={className}>
      <Mask onClick={markAsRead} />
      <AlertHeader label={'alerts'} icon onClick={markAsRead} />
      <LogsItemContainer onClick={(e) => e.stopPropagation()}>
        {!canShowAlerts ? (
          <BasicLoader />
        ) : alertsError ? (
          <ErrorText>There was an error loading the alerts</ErrorText>
        ) : (
          <>
            {totalAlerts.results.map((alert, i) => (
              <AlertItem
                key={`log-${i}`}
                log={alert}
                IDProps={IDProps}
                config={ALERTS_VERBS}
                isAlert
                unread={alert?.unread}
              />
            ))}
            {hasMoreAlerts && (
              <LoaderButtonContainer>
                {isLoadingAlerts ? (
                  <StyledLoader size={10} />
                ) : (
                  <LoadMoreButton
                    onClick={() => {
                      setCurrentPage(currentPage + 1);
                    }}
                  >
                    Load More items
                  </LoadMoreButton>
                )}
              </LoaderButtonContainer>
            )}
          </>
        )}
      </LogsItemContainer>
    </div>
  );
};

export default styled(AlertsList)`
  position: absolute;
  top: 0;
  right: 0;
  width: 420px;
  border-left: 1px solid var(--accent-color-gary);
  background: var(--primary-background);
  height: 100%;
  display: flex;
  flex-direction: column;
`;
